module.exports = __webpack_public_path__ + "media/icons/fit-scale-icon-39cb8c44.svg";